// Public entry point — README.md "API".

import type { EditorDoc } from '@roomtreatment/core';
import type { Product } from '@roomtreatment/av-catalog';
import type { BuildReport, CheckBuildOptions, Issue } from './types';
import { buildContext } from './context';
import { RULE_IDS, RULES } from './rules/registry';
import { buildChecklist } from './checklist';

export function checkBuild(
  doc: EditorDoc,
  catalog: ReadonlyMap<string, Product>,
  opts: CheckBuildOptions,
): BuildReport {
  const ctx = buildContext(doc, catalog, opts);

  const errors: Issue[] = [];
  const warnings: Issue[] = [];
  const unknown: BuildReport['unknown'] = [];

  for (const ruleId of RULE_IDS) {
    const result = RULES[ruleId](ctx);
    for (const issue of result.issues) {
      (issue.severity === 'error' ? errors : warnings).push(issue);
    }
    unknown.push(...result.unknown);
  }

  const items = buildChecklist(ctx);

  return {
    channels: ctx.channels,
    issues: [...errors, ...warnings],
    unknown,
    items,
    counts: { errors: errors.length, warnings: warnings.length },
  };
}
